import queryString from 'query-string'
import { generatePath, matchPath } from 'react-router'

import type { GetStrictLinkToType, RouteParams } from './routes.types'
import { isOptions, isRouteParams } from './typeGuards'

export const unSafeGenerateLink = <T extends string>(
  current: string,
  to: T,
  params: RouteParams<T>,
  query: Record<string, string>,
) => {
  const currentParams = matchPath(window.location.hash.slice(1), { path: current })
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pathname = generatePath(to, { ...currentParams?.params, ...params } as any)
    return `${pathname}?${queryString.stringify(query)}`
  } catch (error) {
    console.error('[unSafeGenerateLink] Error generating path:', {
      current,
      to,
      params,
      currentParams: currentParams?.params,
      error: (error as Error).message,
    })
    throw error
  }
}

const generateLink: GetStrictLinkToType = (...[route, firstArg, secondArg]) => {
  const params = isRouteParams(firstArg) ? firstArg : {}
  const options = isOptions(firstArg) ? firstArg : secondArg

  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pathname = generatePath(route, params as any)

    return {
      pathname,
      search: options?.search,
      state: options?.state,
    }
  } catch (error) {
    console.error('[generateLink] Error generating path:', {
      route,
      params,
      error: (error as Error).message,
    })
    return {
      pathname: '',
    }
  }
}

export default generateLink
